
import { onMounted, ref } from 'vue';
import { useHydration } from 'quasar'
export function useLottie(animationData: any) {
  const animationContainer = ref<HTMLElement | null>(null);

  const { isHydrated } = useHydration()
  onMounted(async() => {
    if (animationContainer.value && isHydrated) {
      const player = document.createElement('lottie-player');
      player.setAttribute('autoplay', '');
      player.setAttribute('loop', '');
      player.setAttribute('mode', 'normal');
      // Convert animation data to a string if it's an object
      const animationString = typeof animationData === 'string'
        ? animationData
        : JSON.stringify(animationData);
      player.setAttribute('src', animationString);

      animationContainer.value.appendChild(player);
    }
  });

  return {
    animationContainer
  };
}
